import apiServers from "../shared/api-servers";

// add new servers to ../shared/api-servers
export default {
  apiServers,
};
